<template>
<div>
   <vs-row vs-type="flex" vs-justify="space-between">
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="12" class="m-3" >  
        <feather-icon id="refreshButton" style="display:none" icon="RefreshCcwIcon" class="cursor-pointer mr-5" svg-classes="h-8 w-8" @click="refresh" />
         <feather-icon id="openButton" style="display:none" icon="ShareIcon" class="cursor-pointer" svg-classes="h-8 w-8" @click="open" />
      </vs-col>
   </vs-row>
    <div class="powerBiContainer">
      <div id="reportContainer" />
    </div>
  </div>
</template>

<script>
import { service, factories, models } from "powerbi-client";

export default {
  props: {
    reportParams: {
      type: String,
      default: "",
      required: false
    },
    pageId: {
      type: String,
      default: "",
      required: false
    },
    materialTypeNames: {
      type: Array,
      default : () => ['Ore'],
      required: false
    },
    showMaterialType: {
      type: Boolean,
      default: false
    },
    isPaginated: {
      type: Boolean,
      default: false
    },
    showNavPane: {
      type: Boolean,
      default: true
    }  
  },
  data() {
    return {
      props: {
        msg: String
      },
      isLoaded : false
    };
  },
  mounted() {
    const pageId = this.$props.pageId;
    
    this.$auth.getPowerBiToken().then(
      token => {
        this.$powerBiApi.get("/myorg/groups/" + this.$store.state.powerbiConfigurations.powerBiGroupId + "/reports/" + this.$store.state.powerbiConfigurations.gradeControl).then(
          response => {
            const replaceFilter = models.FiltersOperations.Replace;
            const projectId = this.$store.state.projectId;
            const materialTypeNames = this.$props.materialTypeNames;
            const showMaterialType = this.$props.showMaterialType;
            const showNavPane = this.$props.showNavPane;
            const config = {
              type: "report",
              tokenType: models.TokenType.Aad,
              accessToken: token.accessToken,
              embedUrl: response.data.embedUrl + this.$props.reportParams + "&rp:ProjectId=" + projectId,
              id: this.$props.reportId,
              permissions: models.Permissions.All,
              settings: {
                filterPaneEnabled: true,
                navContentPaneEnabled: showNavPane,
                layoutType: models.LayoutType.Custom,
                customLayout: {
                  displayOption: models.DisplayOption.FitToPage
                }
              }
            };

            const powerbi = new service.Service(
              factories.hpmFactory,
              factories.wpmpFactory,
              factories.routerFactory
            );

            const reportContainer = document.getElementById("reportContainer");
            const report = powerbi.embed(reportContainer, config);

            // Report.off removes a given event handler if it exists.
            report.off("loaded");

            // Report.on will add an event handler which prints to Log window.
            report.on("loaded", function () {
              console.log("Loaded");
              const refreshButton = document.getElementById("refreshButton")
              refreshButton.style.display = "block"

              const openButton = document.getElementById("openButton")
              openButton.style.display = "block"
              
              report.getPages().then(function (pages) {
                if (pageId !== "") {
                  pages[pageId].setActive();
                }
              });
              
             
              const projectFilter = {
                "$schema":"http://powerbi.com/product/schema#basic",
                "target": {
                  table:"Projects",
                  column:"Id"
                },
                "filterType":1,
                "operator":"In",
                "values": [parseInt(projectId)],
                "requireSingleSelection":true,
                "displaySettings" : {
                  isHiddenInViewMode : true
                }
              }

              const muckTypeFilter = {
                "$schema":"http://powerbi.com/product/schema#basic",
                "target": {
                  table:"MaterialType",
                  column:"Name"
                },
                "filterType":1,
                "operator":"In",
                "values": materialTypeNames,
                "requireSingleSelection":false,
                "displaySettings" : {
                  isHiddenInViewMode : !showMaterialType
                }
              }

              console.log("Getting filters");
              report.getFilters().then(
                filters => {
                  console.log("Pushing filters");

                  // Force project add project Id filter
                  filters.push(projectFilter);
                  filters.push(muckTypeFilter);

                  report.updateFilters(replaceFilter, filters);
                });
              
            });

            // Report.off removes a given event handler if it exists.
            report.off("rendered");

            // Report.on will add an event handler which prints to Log window.
            report.on("rendered", function () {
              console.log("Rendered");
            });

            report.on("error", function (event) {
              console.log(event.detail);
              report.off("error");
            });

            report.off("saved");
            report.on("saved", function (event) {
              if (event.detail.saveAs) {
                console.log(
                  "In order to interact with the new report, create a new token and load the new report"
                );
              }
            });


          }
        );
      }
    );
  },
  methods: {
    refresh() {
      const powerbi = new service.Service(
        factories.hpmFactory,
        factories.wpmpFactory,
        factories.routerFactory
      );

      const element = document.getElementById('reportContainer');
      const report = powerbi.get(element);
      
      report.refresh();
    },
    open() {
      const materialTypes = this.$props.materialTypeNames.join("','");
      window.open("https://app.powerbi.com/groups/" + this.$store.state.powerbiConfigurations.powerBiGroupId + "/reports/" + this.$store.state.powerbiConfigurations.gradeControl + "?filter=Projects/Id in (" + this.$store.state.projectId + ") and MaterialType/Name in ('" + materialTypes + "')") 
    }
  }
};
</script>
<style lang="scss">
  #reportContainer {
    width: 100%;
    height: calc(100vh - 220px);
    min-height: 700px;

    iframe {
      border: 1px solid white;
      padding: 15px;
      background: white;
      border-radius: 6px;
      box-sizing: border-box;
    }
  }
</style>
